$(document).ready(function() {
  $('.wa-cat-link').click(function(e) {
    e.preventDefault();
    $(this).parent('.wa-category').toggleClass('open');
    $(this).siblings('.wa-subcategories').toggleClass('open');
  });

  $('.wa-subcat-link').click(function(e) {
    e.preventDefault();
    $(this).parent('.wa-subcategory').toggleClass('open');
    $(this).siblings('.wa-products').toggleClass('open');
  });
});




function toggleVideo() {
            var img = document.querySelector('.waimg');
            var video = document.querySelector('.wavideo');
            
            img.style.display = 'none';
            video.style.display = 'block';
        }
/**/
 // Get references to the elements
  var wabtnmap = document.getElementById("wabtnmap");
  var modal = document.getElementById("myModal");
  var span = document.getElementsByClassName("close")[0];

  // Function to open the modal
  function openModal() {
    modal.style.display = "block";
  }

  // Function to close the modal
  function closeModal() {
    modal.style.display = "none";
  }

  // Event listener for the click on wabtnmap
  wabtnmap.addEventListener("click", openModal);

  // Event listener for the close button in the modal
  span.addEventListener("click", closeModal);

  // Event listener to close the modal if the user clicks outside of it
  window.addEventListener("click", function(event) {
    if (event.target === modal) {
      closeModal();
    }
  });